import React, { useEffect } from 'react';

import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectResearchAssistantMessages } from '@verantos-dev/app-state-research-assistant';

export const useScrollMessageIntoView = () => {
  const messagesEndRef = React.useRef<null | HTMLDivElement>(null);
  const chatWindowRef = React.useRef<HTMLDivElement>(null);

  const messages = useAppSelector(selectResearchAssistantMessages);

  // Scroll to bottom of chat window
  const scrollToBottom = () => {
    if (messagesEndRef.current && chatWindowRef.current) {
      const messageRect = messagesEndRef.current.getBoundingClientRect();
      const chatWindowRect = chatWindowRef.current.getBoundingClientRect();
      const isInView = messageRect.bottom <= chatWindowRect.bottom;
      if (!isInView) {
        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  // Scroll to bottom when new message is added
  useEffect(scrollToBottom, [messages]);

  return {
    chatWindowRef,
    messagesEndRef,
  };
};
